import {widgetGroupFactory} from './index';

export default {
    parse(configuredData,params){
        return new Promise(async (ress,rej)=>{
            var res = [];

            if(configuredData.length){
                for(var i=0;i<configuredData.length;i++){
                    let widgetTemplate = await widgetGroupFactory.get(configuredData[i]);
                    if(widgetTemplate instanceof Function){
                        const generatedWidgits = await widgetTemplate();
                        generatedWidgits.$$each(w=>res.push(w));
                        //res.push({type:'new-line'});
                    }else{
                        res.push({type:widgetTemplate});
                    }
                }
            }

            ress(res);
        });
    }
}